exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".btns[data-v-1203ce63] {\n  position: absolute;\n  right: 0.1rem;\n  bottom: 0.2rem;\n}\n.btns i[data-v-1203ce63] {\n  font-size: 16px;\n  color: #666;\n  margin: 0 0.7rem;\n  cursor: pointer;\n}\n.btns i[data-v-1203ce63]:hover {\n  opacity: 0.8;\n}\n", ""]);

// exports
